/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_GeneratedInputs */

const cs_tasks_protocol_generated = /** @type {(inputs: Tasks_Protocol_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokol vygenerován`)
};

const en_tasks_protocol_generated = /** @type {(inputs: Tasks_Protocol_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protocol generated`)
};

/**
* | output |
* | --- |
* | "Protocol generated" |
*
* @param {Tasks_Protocol_GeneratedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_generated = /** @type {((inputs?: Tasks_Protocol_GeneratedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_GeneratedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_generated(inputs)
	return cs_tasks_protocol_generated(inputs)
});